import StringUtils from "./StringUtils";
import DataObj from "../class/DataObj";
// import { parse } from '@fortawesome/fontawesome-svg-core';
// import VideoFrame from './VideoFrame/VideoFrame';
// const Timecode = require('smpte-timecode');
export default class TimeUtils {
  /**
   * InTimecode OutTimecode　的　NaN檢察點到 NaN:NaN:NaN,NaN
   * */
  static InTimecodeOutTimecodeCheck(data) {
    let newDataArray = [];

    data.map((dataObj) => {
      let newData = dataObj;

      newData.setInOut("In", newData.In);
      newData.setInOut("Out", newData.Out);

      if (newData["In"] !== "" && newData["Out"] !== "") {
        if (
          newData["InTimecode"] === "NaN:NaN:NaN,NaN" ||
          newData["InTimecode"] === null
        ) {
          newData["InTimecode"] = TimeUtils.getTimecodeFromTimestring(
            newData["In"]
          );
        }
        if (
          newData["OutTimecode"] === "NaN:NaN:NaN,NaN" ||
          newData["OutTimecode"] === null
        ) {
          newData["OutTimecode"] = TimeUtils.getTimecodeFromTimestring(
            newData["Out"]
          );
        }
        newDataArray.push(newData);
      }
    });

    return newDataArray;
  }

  /**
   * 台灣時間
   * @param  targetTime 要顯示時間
   * @return {string}
   * */
  static setTaiwan(targetTime) {
    // Date.prototype.addHours= function(h){
    //     this.setHours(this.getHours()+h);
    //     return this;
    // }
    let targetDate;

    let isDateString = targetTime.includes("/Date(");
    targetDate = new Date(targetTime);
    if (isDateString === true) {
      targetDate = TimeUtils.getDateFromDateString(targetTime);
    }

    //目標 ts
    let targetDateTS = targetDate.getTime();

    //扣掉八小時
    targetDateTS = parseFloat(targetDateTS) - 8 * 60 * 60 * 1000;

    //現在
    let nowDate = new Date();
    let nowDateTS = nowDate.getTime();

    let d = new Date(targetDateTS); //目標
    let nd = new Date(nowDateTS); //現在

    //   let d = new Date(targetTime).addHours(8);
    // let d = new Date(targetTime);
    //
    let dformat =
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
      " " +
      [d.getHours(), d.getMinutes()].join(":");

    let month = d.getMonth() + 1;
    if (month < 10) {
      month = `0${d.getMonth() + 1}`;
    }
    let Dates = d.getDate();
    if (Dates < 10) {
      Dates = `0${d.getDate()}`;
    }
    let Hours = d.getHours();
    if (Hours < 10) {
      Hours = `0${d.getHours()}`;
    }
    let Minutes = d.getMinutes();
    if (Minutes < 10) {
      Minutes = `0${d.getMinutes()}`;
    }

    // 2019-10-29 22:00:00

    // return `${month}/${Dates}/${d.getFullYear()} ${Hours}:${Minutes}`;
    return `${d.getFullYear()}-${month}-${Dates} ${Hours}:${Minutes}`;
    // return `${nowDateTS} ///// ${targetDateTS}`;
  }

  /**
   * 前端時間
   * @param  getDateFromDateString 要顯示時間
   * @return {Date}
   * */
  static getDateFromDateString(releaseDate) {
    let releaseDateString = releaseDate.replace("/Date(", "");
    releaseDateString = releaseDateString.replace("/", "");
    releaseDateString = releaseDateString.replace(")", "");

    let TS = parseFloat(releaseDateString);

    return new Date(TS);
  }

  /**
   * 前端時間
   * @param  frames 不足1秒的數量
   * @return {Date}
   * */
  static convertFramesToMillisecond(frames) {
    if (frames === 0) {
      return "000";
    }

    const videoFps = TimeUtils.getFPS();

    const Millisecond = (frames / parseFloat(videoFps)) * 1000;

    if (`${Millisecond}`.length === 1) {
      return `00${Millisecond}`;
    } else if (`${Millisecond}`.length === 2) {
      return `0${Millisecond}`;
    } else {
      return `${Millisecond}`.substr(0, 3);
    }
  }

  /**
   * Frame 轉換到timecode
   * @param  frames
   * @return {Date}
   * */
  static convertFramesToTimestring(frames) {
    const fps = TimeUtils.getFPS();
    let baseframe = Math.round(frames % fps);
    if (baseframe < 10) {
      baseframe = "0" + baseframe;
    }

    var sec_num = parseInt(frames / TimeUtils.getFPS(), 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
      hours = "0" + hours;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return hours + ":" + minutes + ":" + seconds + "." + baseframe;
  }

  /*
   * 取得最上方的時間軸的位置
   * */
  static getHandleDragValue() {}

  /*
   * 把不足一秒的部分，轉為1000進位 返回字串
   * */
  static convertExportString(timeString, seconds, videoFps) {
    if (timeString === "") {
      return "00:00:00.00";
    }

    let secounsArray1 = timeString.split(":");
    let secounsOnj0 = secounsArray1[0];
    let secounsOnj1 = secounsArray1[1];

    //分為秒跟frame
    let secounsOnj2 = secounsArray1[2];
    let secounsFrameArray = secounsOnj2.split(".");

    let secound = secounsFrameArray[0];

    //取得毫秒
    const millisecond = TimeUtils.getMillisecond_from_seconds(seconds);

    // let frame = secounsFrameArray[1];
    //
    // // let newEnd = parseInt(frame/videoFps*1000,10);
    //
    // let newEnd = parseFloat(frame)*(1/videoFps);
    //
    // console.log(`檢查輸出 錯 ${parseFloat(frame)} * ${(1/videoFps)} = ${newEnd} `);
    // //補0
    // let newEndString = `${newEnd}`;
    // if(newEnd < 100){
    //     newEndString = `0${newEnd}`;
    // }else if(newEnd < 10){
    //     newEndString = `00${newEnd}`;
    // }
    //
    // if(newEnd === 0){
    //     newEndString = `000`;
    // }

    return `${secounsOnj0}:${secounsOnj1}:${secound},${millisecond}`;
  }

  /**
   * 透過string title 對於frame增減 不捨去
   * */
  static useStringCountFrame(q_timeString, videoFps, countNumber) {
    //總數
    let frameNumber = TimeUtils.timeString_convertTo_frame(
      q_timeString,
      videoFps
    );

    //計算
    frameNumber = frameNumber + countNumber;

    //秒數
    const totalseconds = frameNumber / videoFps;

    //return timeStringTitle;
    const dateObj = new Date(totalseconds * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    const m_seconds = dateObj.getMilliseconds();

    const timeString =
      hours.toString().padStart(2, "0") +
      ":" +
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0") +
      "." +
      m_seconds.toString().padStart(3, "0");

    let millisecond = m_seconds.toString().padStart(3, "0");
    let frames_per_millisecond = parseFloat(videoFps) / 1000;
    let finalFram = Math.round(millisecond * frames_per_millisecond);

    let frameString = "";
    if (`${parseInt(finalFram)}`.length === 1) {
      frameString = `0${parseInt(finalFram)}`;
    } else {
      frameString = `${parseInt(finalFram)}`;
    }

    return hours + ":" + minutes + ":" + seconds + "." + frameString;
  }
  /**
   * 檢查影格間距
   * */
  static getFrameSplitErrorArray(data, findFrameSplitValue, videoFps) {
    if (data === null) {
      return;
    }

    //檢察findFrameSplitValue
    let findFrameSplitErrorArray = [];
    data.forEach(function (ROWoBJ, index) {
      // type(pin):"Out"
      // rowIndex(pin):0
      // nextIndex(pin):1
      // outTime(pin):"00:00:00.12"

      // 只有最後一個沒有間距
      if (index !== data.length - 1) {
        const nextROWoBJ = data[index + 1];
        const currentInString = ROWoBJ.In;
        const currentOutString = ROWoBJ.Out;
        const nextInString = nextROWoBJ.In;

        const currentInFrame =
          TimeUtils.timeString_convertTo_frame(currentInString);

        const currentFrame =
          TimeUtils.timeString_convertTo_frame(currentOutString);

        const nextFrame = TimeUtils.timeString_convertTo_frame(nextInString);
        //
        // const countFrameNumber = Math.ceil(nextFrame - currentFrame);

        let frameCount = nextFrame - currentFrame;

        let durationFrame =
          parseFloat(currentFrame) - parseFloat(currentInFrame);

        if (durationFrame < 0) {
          //自己的時間不對
          findFrameSplitErrorArray.push({
            type: false,
            rowIndex: index,
          });
        } else if (nextFrame === 0) {
          //下一格都沒有時間 不是錯
          findFrameSplitErrorArray.push({
            type: true,
            rowIndex: index,
          });
        } else if (nextFrame === 0 && currentFrame === 0) {
          //下一格都沒有時間 不是錯
          findFrameSplitErrorArray.push({
            type: true,
            rowIndex: index,
          });
        } else if (frameCount < findFrameSplitValue) {
          //時間的間格小於
          findFrameSplitErrorArray.push({
            type: false,
            rowIndex: index,
          });

          //console.log(`countFrameNumber 錯 ${index} ${frameCount}  ${findFrameSplitValue+1} `);
        } else {
          findFrameSplitErrorArray.push({
            type: true,
            rowIndex: index,
          });
          // console.log(`countFrameNumber 對 ${index} ${frameCount} ${findFrameSplitValue+1} `);
        }
      } else {
        findFrameSplitErrorArray.push({
          type: true,
          rowIndex: index,
        });
        // console.log(`countFrameNumber 對 ${index}   `);
      }
    });

    return findFrameSplitErrorArray;
  }

  /** 從秒數　取得　row index
   * lastRow:從最後一個來取
   * */
  static secondsConvertToRowIndew_whenPlaying(
    seconds,
    videoFps,
    DataObjArray,
    newlastRow
  ) {
    // DataObjArray
    //如果秒數都小於第一個out 那就是返回0
    let firstObj = new DataObj(DataObjArray[0]);
    if (parseFloat(seconds) <= parseFloat(firstObj.end)) {
      return 0;
    }

    let currendIndex = 0;
    for (let i = 0; i < DataObjArray.length; i++) {
      if (i === DataObjArray.length - 1) {
        //最後一個
        currendIndex = i;
        break;
      } else if (i > 0) {
        /**
         * 此處判斷　第二個到倒數第二個之間的index
         * 我的開始跟下一個的開始之間
         */
        const obj = new DataObj(DataObjArray[i]);
        let currentOutSecond = obj.end;

        if (parseFloat(seconds) <= currentOutSecond) {
          currendIndex = i;
          return i;
        }
      }
    }
    return currendIndex;
  }
  //從秒數　取得　row index
  static secondsConvertToRowIndew(seconds, videoFps, data) {
    if (data === null) {
      return 0;
    }

    //取得第一個開始的時間 小於第一個開始的時間 index都要是0
    let firstObj = data[1];
    let firstTimeString = firstObj.In;
    let firstInSecond = parseFloat(
      TimeUtils.stringConvertToSeconds(firstTimeString, videoFps)
    );

    // console.log(`secondsConvertToRowIndew ${seconds} ${firstInSecond}  ${videoFps}  ${firstTimeString}`);

    if (parseFloat(seconds) <= parseFloat(firstInSecond)) {
      return 0;
    }

    let currendIndex = 0;
    for (let i = 0; i < data.length; i++) {
      if (seconds === 0) {
        //第一個
        // console.log(`secondsConvertToRowIndew 第一個`);
        currendIndex = 0;
        break;
      } else if (i === data.length - 1) {
        // console.log(`secondsConvertToRowIndew 最後一個`);
        //最後一個
        currendIndex = i;
      } else {
        const obj = data[i];
        const nextObj = data[i + 1];
        const { In } = obj;
        const nextIn = nextObj.In;

        let currentFrame = parseFloat(videoFps * seconds);
        let inSecondFrame = parseFloat(
          TimeUtils.timeString_convertTo_frame(In)
        );
        let nextInSecond = parseFloat(
          TimeUtils.timeString_convertTo_frame(nextIn)
        );

        // console.log(`secondsConvertToRowIndew 中間 ${inSecond} `);

        if (
          parseFloat(inSecondFrame) <= parseFloat(currentFrame) &&
          parseFloat(nextInSecond) > parseFloat(currentFrame)
        ) {
          currendIndex = i;
          break;
        }
      }
    }
    return currendIndex;
  }

  /**
   * 從秒數變成frame
   * */
  static convertSecondToFrame(second, videoFps) {
    // let secounsArray1 = `${second}`.split(".");
    // let littleFramNum = parseFloat(`0.${secounsArray1[1]}`);
    //
    // let currentFram = parseFloat(secounsArray1[0])*videoFps + littleFramNum/videoFps;

    return parseFloat(second) * videoFps;
  }

  /**
   * 從秒數 取得毫秒
   * */
  static getMillisecond_from_seconds(second) {
    //console.log(`getMillisecond_from_seconds : ${second}`)
    const dateObj = new Date(second * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    const m_seconds = dateObj.getMilliseconds();

    const timeString =
      hours.toString().padStart(2, "0") +
      ":" +
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0") +
      "." +
      m_seconds.toString().padStart(3, "0");

    return m_seconds.toString().padStart(3, "0");

    // let millisecond = 0;
    // if(`${second}`.includes('.') === true){
    //     //要處理frame
    //
    //     const SecondArray = `${second}`.split('.');
    //     millisecond = SecondArray[1];
    //
    //     if(millisecond.length === 1){
    //         millisecond = `${millisecond}00`
    //     }else if(millisecond.length === 2){
    //         millisecond = `${millisecond}0`
    //     }else{
    //         millisecond = millisecond.substr(0,3);
    //     }
    //
    //     return millisecond;
    // }else{
    //     return '000';
    // }
  }

  /**
   * 從秒數 進入到前端60進位顯示
   * */
  static convertSecondToTimeString(q_second, videoFps) {
    // const timecode = require('smpte-timecode');
    // var eightHundredFrames = new timecode(parseFloat(q_second),TimeUtils.getFPS(),false);
    // console.log('eightHundredFrames q_second ' + q_second);
    // console.log('eightHundredFrames eightHundredFrames ' + eightHundredFrames);

    let second = q_second;
    // console.log(`convertSecondToTimeString second ${second}`)
    //
    var pad = function (input) {
      return input < 10 ? "0" + input : input;
    };
    // // fps = (typeof fps !== 'undefined' ?  fps : 24 );
    //
    // return `${ pad(Math.floor(input / 3600))}:${pad(Math.floor(input % 3600 / 60))}:${pad(Math.floor(input % 60))}.${pad(Math.floor(input * fps % fps))}`;

    if (second < 0) {
      return "";
    } else {
      if (second === 0) {
        return "00:00:00.00";
      }

      //return timeStringTitle;
      const dateObj = new Date(second * 1000);
      const hours = dateObj.getUTCHours();
      const minutes = dateObj.getUTCMinutes();
      const seconds = dateObj.getSeconds();
      const m_seconds = dateObj.getMilliseconds();
      // const hours = dateObj.getUTCHours();
      // const minutes = dateObj.getUTCMinutes();
      // const seconds = dateObj.getSeconds();
      // const m_seconds = dateObj.getMilliseconds();

      const timeString =
        hours.toString().padStart(2, "0") +
        ":" +
        minutes.toString().padStart(2, "0") +
        ":" +
        seconds.toString().padStart(2, "0") +
        "." +
        m_seconds.toString().padStart(3, "0");

      let millisecond = m_seconds.toString().padStart(3, "0");
      let frames_per_millisecond = parseFloat(videoFps) / 1000;
      let finalFram = millisecond * frames_per_millisecond;

      // const secondArray = `${q_second}`.split('.');
      // if(secondArray.length > 1){
      //     //毫秒轉成frame
      //     const LessThanOnesecond = parseFloat(`0.${secondArray[1]}`);
      //     finalFram = videoFps * LessThanOnesecond;
      //     const totalFram = videoFps * q_second;
      //
      //     console.log('----------------------------------');
      //     console.log('totalFram ' + totalFram);
      //     console.log('videoFps ' + videoFps);
      //     console.log('finalFram ' + finalFram);
      //     console.log('毫秒轉成frame ' + q_second);
      //     console.log('LessThanOnesecond ' + LessThanOnesecond);
      // }

      let frameString = "";

      if (`${Math.floor(finalFram)}`.length === 1) {
        frameString = `0${Math.floor(finalFram)}`;
      } else {
        frameString = `${Math.floor(finalFram)}`;
      }
      // console.log(`1 =
      //     =second:${second}
      //     =millisecond:${millisecond}
      //     =finalFram:${finalFram}
      //     =frames_per_millisecond:${frames_per_millisecond}
      //     = finalFram:${frames_per_millisecond}
      //     =最後結果 finalFram:${finalFram}======================================`);
      // console.log(`1 =
      //     =second:${second}
      //     =millisecond:${millisecond}
      //     =finalFram:${finalFram}
      //     =frames_per_millisecond:${frames_per_millisecond}
      //     =最後結果 timeStringTitle:${timeString}======================================`);

      // if(totalFram === 24){
      //     totalFram = '00';
      //     second += 1;
      // }

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}.${frameString}`;
    }
  }

  //記憶體儲存
  static getFPS() {
    // var videoFpsString = parseFloat(document.getElementById('fpsButton').innerHTML);

    // var videoFps = parseFloat(videoFpsString.replace("FPS",""));

    // return videoFps;

    let currentFPS = parseFloat(window.videoFps);

    if (currentFPS === 23.98) {
      currentFPS = 24;
    } else if (currentFPS === 29.97) {
      currentFPS = 30;
    }

    return currentFPS;
  }

  /**
   * 利用frame的扣除 回傳 timestring
   * */
  static getTimeStringFrom_Frame_deduction(
    targetTimeString,
    deFrameCount,
    videoFps
  ) {
    let secounsArray1 = `${targetTimeString}`.split(":");
    let secounsOnj0 = secounsArray1[0]; //小時
    let secounsOnj1 = secounsArray1[1]; //分鐘

    //分為秒跟frame
    let secounsOnj2 = secounsArray1[2];
    let secounsFrameArray = secounsOnj2.split(".");
    let secounsOnj3 = secounsFrameArray[0]; //秒
    let secounsOnj4 = secounsFrameArray[1]; //frame

    let frameString = secounsOnj4.toString().padStart(2, "0");

    let finalFrameCount =
      Math.round(parseFloat(secounsOnj4) + deFrameCount) + 1;
 

    if (finalFrameCount < 0) {
      finalFrameCount = Math.round(
        videoFps + parseFloat(secounsOnj4) + deFrameCount
      );

      //如果秒數在　00的話，要往下扣１秒，分鐘也要往下扣
      //處理秒數
      if (parseFloat(secounsOnj3) === 0) {
        secounsOnj3 = 59;

        //如果分鐘數是０，要往小時扣１
        if (parseFloat(secounsOnj1) === 0) {
          secounsOnj1 = 59;

          //檢查小時
          if (parseFloat(secounsOnj0) === 0) {
          } else {
            //小時正常扣１
            secounsOnj0 = parseFloat(secounsOnj0) - 1;
          }
        } else {
          //分鐘正常扣1
          secounsOnj1 = parseFloat(secounsOnj1) - 1;
        }
      } else {
        //秒數正常扣１
        secounsOnj3 = parseFloat(secounsOnj3) - 1;
      }
    }

    return `${secounsOnj0.toString().padStart(2, "0")}:${secounsOnj1
      .toString()
      .padStart(2, "0")}:${secounsOnj3
      .toString()
      .padStart(2, "0")}.${finalFrameCount.toString().padStart(2, "0")}`;
  }

  /**
   * 從adjust frame SplitError
   * */
  static getTimeString_byframeSplitError(In_next, _frameCheckValue, _FPS) {
    const In_nextArray = In_next.split(":");
 

    //秒跟frame
    const frameString = In_nextArray[2];
    const frameArray = frameString.split(".");

    //檢查frame
    let exat_frame = parseFloat(frameArray[1]);

    //結果 frame
    let final_frame = exat_frame - _frameCheckValue;

    //秒
    let exat_second = parseFloat(frameArray[0]);
    let final_second = exat_second;

    //如果frame扣到0以下 要跟
    if (final_frame < 0) {
      //因為是扣到負數所以用 +
      final_frame = _FPS + final_frame;

      //秒數要扣1
      exat_second = parseFloat(exat_second) - 1;

      final_second = final_second - 1;
    }

    //檢查分
    let exat_mint = parseFloat(In_nextArray[1]);
    let final_mint = exat_mint;

    //檢查秒數
    //如果秒數扣到0以下 要跟
    if (parseFloat(final_second) < 0) {
      //因為是扣到負數所以用 +
      exat_second = 60 + parseFloat(exat_second);

      //分要扣掉1
      exat_mint = parseFloat(exat_mint) - 1;

      final_mint = final_mint - 1;
    }

    //檢查分
    let exat_hour = parseFloat(In_nextArray[0]);

    if (parseFloat(final_mint) < 0) {
      //因為是扣到負數所以用 +
      exat_mint = 60 + parseFloat(exat_mint);

      //分要扣掉1
      exat_hour = parseFloat(exat_hour) - 1;
    }

    return `${exat_hour}:${exat_mint}:${exat_second}.${final_frame}`;
  }

  static displayTime(currentFrame, videoFps) {
    var fps = videoFps;
    var h = Math.floor(currentFrame / (60 * 60 * fps));
    var m = Math.floor(currentFrame / (60 * fps)) % 60;
    var s = Math.floor(currentFrame / fps) % 60;
    var f = currentFrame % fps;
    return (
      TimeUtils.showTwoDigits(h) +
      ":" +
      TimeUtils.showTwoDigits(m) +
      ":" +
      TimeUtils.showTwoDigits(s) +
      "." +
      TimeUtils.showTwoDigits(f)
    );
  }

  static showTwoDigits(number) {
    return ("00" + number).slice(-2);
  }

  /**
   * 從時間點到frame的數量
   * */
  static getTimeStringFrom_FrameCount(deFrameCount, videoFps) {
    return TimeUtils.displayTime(deFrameCount, videoFps);
  }

  /**
   * 從timeString 點到 seconds
   * */
  static stringConvertToSeconds(timeString, videoFps) {
    // console.log(`timeString ${timeString}`);

    if (timeString === "00:00:00.00") {
      return 0;
    }
    if (timeString === "00:00:00") {
      return 0;
    }
    if (timeString.includes(":") === false) {
      return 0;
    }
    if (timeString.includes(".") === false) {
      return 0;
    }

    if (timeString === "") {
      return 0;
    }

    //檢察:兩個 .一個
    let colonCount = 0;
    let commaCount = 0;
    for (let i = 0; i < timeString.length; i++) {
      // alert(str.charAt(i));
      if (timeString[i] === ":") {
        colonCount += 1;
      }
      if (timeString[i] === ".") {
        commaCount += 1;
      }
    }
    if (colonCount !== 2) {
      return 0;
    }
    if (commaCount !== 1) {
      return 0;
    }

    // if(){
    //
    // }

    let secounsArray1 = `${timeString}`.split(":");
    let secounsOnj0 = secounsArray1[0];
    let secounsOnj1 = secounsArray1[1];

    //分為秒跟frame
    let secounsOnj2 = secounsArray1[2];
    let secounsFrameArray = secounsOnj2.split(".");

    let frameString = secounsFrameArray[1].toString().padStart(2, "0");

    // let videoFps = TimeUtils.getFPS();

    // if(`${parseFloat(frameString)}`.length === 1) {
    //     frameString = `${frameString}0`;
    // }

    // console.log(`getTimeStringFrom_FrameCount -----------------------------------------`);
    // console.log(`getTimeStringFrom_FrameCount timeString ${timeString}`);

    //let TimeTitle = `${timeString}`.replace('.',":");
    //let timecodeObj = new Timecode(TimeTitle);
    //
    // console.log(`getTimeStringFrom_FrameCount frameCount ${timecodeObj.frameCount}`);
    // console.log(`getTimeStringFrom_FrameCount seconds ${timecodeObj.seconds}`);
    // console.log(`getTimeStringFrom_FrameCount frameRate ${timecodeObj.frameRate}`);
    // console.log(`getTimeStringFrom_FrameCount minutes ${timecodeObj.minutes}`);
    // console.log(`getTimeStringFrom_FrameCount frames ${timecodeObj.frames}`);

    return (
      parseFloat(secounsOnj0) * 60 * 60 +
      parseFloat(secounsOnj1) * 60 +
      parseFloat(secounsFrameArray[0]) +
      parseFloat(frameString) / videoFps
    );

    // console.log(`
    //
    // secounsFrameArray[1].toString().padStart(2, '0')  ${secounsFrameArray[1].toString().padStart(2, '0')}
    // secounsFrameArray[1] ${secounsFrameArray[1]}
    // frameString ${frameString}
    // parseFloat(frameString)/videoFps ${parseFloat(frameString)/videoFps}
    // seconds ${seconds}
    //
    // `)
    //return seconds;
  }

  /**
   * 從操作端的 timestring 取得 Timecode
   * */
  static getTimecodeFromTimestring(timestring) {
    const timeArray = `${timestring}`.split(":");
    const secondArray = `${timeArray[2]}`.split(".");

    let frameString = secondArray[1];
    if (`${frameString}`.length === 1) {
      frameString = `${frameString}0`;
    }

    //frame convert to Milliseconds

    return `${timeArray[0]}:${timeArray[1]}:${
      secondArray[0]
    },${TimeUtils.convertFramesToMillisecond(parseFloat(frameString))}`;
  }

  /**
   * 從 Timecode  取得 操作端的 timestring
   * */
  static getTimestringFromTimecode(Timecode) {
    const timeArray = `${Timecode}`.split(",");
    const millisecond = parseFloat(`${timeArray[1]}`);

    const videoFps = TimeUtils.getFPS();
    const frame = millisecond * (parseFloat(videoFps) / 1000);

    return `${timeArray[0]}.${frame.toString().padStart(2, "0")}`;
  }
  /**
   * 從秒數 取得 Timecode
   * */
  static getTimecodeFromSeconds(given_seconds) {
    const dateObj = new Date(given_seconds * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    const m_seconds = dateObj.getMilliseconds();

    const timeString =
      hours.toString().padStart(2, "0") +
      ":" +
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0") +
      "." +
      m_seconds.toString().padStart(3, "0");

    return timeString;
  }
  /**
   * 取得秒數 從   Timecode
   * */
  static get_Seconds_From_Timecode(qTimecode) {
    const t = qTimecode.split(":");

    let s = t[2].split(",");

    // Just in case a . is decimal seperator
    if (s.length === 1) {
      s = t[2].split(".");
    }

    let m_seconds = s[1];
    m_seconds = m_seconds.toString().padStart(3, "0");

    let second =
      parseFloat(t[0], 10) * 3600 +
      parseFloat(t[1], 10) * 60 +
      parseFloat(s[0], 10) +
      parseFloat(m_seconds, 10) / 1000;

    return second;
  }

  /**
   * 從秒數 取得 Timecode
   * */
  static get_Export_TimecodeFromSeconds(given_seconds) {
    if (given_seconds === 0) {
      return "00:00:00,000";
    }

    const dateObj = new Date(given_seconds * 1000);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    const m_seconds = dateObj.getMilliseconds();

    const timeString =
      hours.toString().padStart(2, "0") +
      ":" +
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0") +
      "," +
      m_seconds.toString().padStart(3, "0");

    return timeString;
  }
  // /**
  //  * 從時間點到frame的數量
  //  * */
  // static getFrameCount(timeString,videoFps){
  //     //console.log(`timeString ${timeString}`)
  //     if(timeString === '00:00:00.00'){
  //         return 0;
  //     }
  //     if(timeString === ''){
  //         return 0;
  //     }
  //     if(timeString === null || timeString === 'null'){
  //         return 0;
  //     }
  //
  //     const n = timeString.toString().includes(":");
  //     if( n === false){
  //         return 0;
  //     }
  //
  //     let secounsArray1 = `${timeString}`.split(":");
  //     let secounsOnj0 = secounsArray1[0];
  //     let secounsOnj1 = secounsArray1[1];
  //
  //     //分為秒跟frame
  //     let secounsOnj2 = secounsArray1[2];
  //     let secounsFrameArray = secounsOnj2.split(".");
  //
  //
  //     let framNum = parseFloat(secounsOnj0)*60*60*videoFps + parseFloat(secounsOnj1)*60*videoFps + parseFloat(secounsFrameArray[0])*videoFps + parseFloat(secounsFrameArray[1]);
  //
  //     return framNum;
  // }

  /**
   * getDuration
   * */
  static getDuration(In, Out, videoFps) {
    //秒數量
    let InFrame = TimeUtils.timeString_convertTo_frame(In);
    let OutFrame = TimeUtils.timeString_convertTo_frame(Out);

    return OutFrame - InFrame;
  }

  /**
   * 取得經歷的秒數
   * */
  static getDurationSecound(In, Out, videoFps) {
    //秒數量
    let InFrame = TimeUtils.timeString_convertTo_frame(In);
    let OutFrame = TimeUtils.timeString_convertTo_frame(Out);

    let seconds = (OutFrame - InFrame) / videoFps;
    let secondsFirst = Math.floor(seconds); //秒數

    let frameP2 = (OutFrame - InFrame) % 24; //frame數量

    //console.log(`seconds ${seconds} secondsFirst${secondsFirst} frameP2 ${frameP2}  `);

    return `${secondsFirst}.${frameP2}`;
  }

  /**
   * 取得字幕開始的位置
   * @param  In 開始時間
   * @param  videoFps fps
   * @param  frameWidth 每一個frame的寬度
   * @return {number}
   * */
  static getSubStartPosition(In, videoFps, frameWidth) {
    //秒數量
    let InFrame = TimeUtils.timeString_convertTo_frame(In, videoFps);

    // console.log(`framNum ${framNum}` );

    return InFrame * frameWidth;
  }

  /**
   * 計算 Duration
   * @param  videoFps 時間字串
   * @param  時間字串
   * @return {number}
   * */
  static getSRTFrameNumberFromString(timString, videoFps) {
    let framNum = timString * videoFps;
    return framNum;
  }

  //從時間字串 變成frame 總數量
  /**
   * @param rowTimString 前端字串
   */
  static timeString_convertTo_frame(rowTimString) {
    // if(rowTimString === ""){
    //     return 0
    // }
    // let videoFps = TimeUtils.getFPS();
    //
    // var timecodeObj = new Timecode(rowTimString.replace(".",";"),videoFps,false);
    //
    // return  timecodeObj.frameCount;

    let videoFps = TimeUtils.getFPS();

    const timString = StringUtils.ckeckOnlyEightNumber(rowTimString);

    //秒數量
    let secounsArray1 = timString.split(":");
    let secounsOnj0 = parseFloat(secounsArray1[0]);
    let secounsOnj1 = parseFloat(secounsArray1[1]);

    //分為秒跟frame
    let secounsOnj2 =  secounsArray1[2];
    let secounsFrameArray = secounsOnj2.split(".");

    let frameString = secounsFrameArray[1];
    if (`${frameString}`.length === 1) {
      frameString = `${frameString}0`;
    }

    let FrameCount = parseFloat(frameString);

    let final =
      parseFloat(secounsOnj0 * 60 * 60 * videoFps) +
      parseFloat(secounsOnj1 * 60 * videoFps) +
      parseFloat(secounsFrameArray[0]) * videoFps +
      parseFloat(FrameCount);

    // console.log(`getTimeStringFrom_FrameCount final ${final}`);

    return Math.round(final);
  }

  // 實現一個等待函數
  static delay(interval) {
    return new Promise((resolve) => {
      setTimeout(resolve, interval);
    });
  }
}



// WEBPACK FOOTER //
// ./src/helper/TimeUtils.js